export const ACTIONS = {
  RESET_ANALYTiCS_TRACKER: 'RESET_ANALYTiCS_TRACKER',
};

export const resetAnalyticsTacker = payload => ({
  type: ACTIONS.RESET_ANALYTiCS_TRACKER,
  payload,
});
